// import Swiper JS
import Swiper, { Autoplay, Navigation } from 'swiper';
// import Swiper styles
import 'swiper/css';

// configure Swiper to use modules
Swiper.use([Navigation]);

export function initSlimLineBrandLogoCarousel() {
  if (window.acf) {
    window.acf.addAction(
      'render_block_preview/type=slim-line-brand-logos',
      slimLineBrandLogoCarousel
    );
  }
}

export function slimLineBrandLogoCarousel() {
  if (!document.querySelector('.slim-line-brand-logos.swiper')) return;

  var swiper = Swiper;
  var init = false;

  let slides = document.querySelectorAll(
    '.slim-line-brand-logos.swiper > .swiper-wrapper > div'
  );

  let wrapper = document.querySelector(
    '.slim-line-brand-logos.swiper > .swiper-wrapper'
  );

  let buttons = document.querySelectorAll(
    '.slim-line-brand-logos-next, .slim-line-brand-logos-prev'
  );

  function swiperMode() {
    let mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)');
    // Enable (for mobile)
    if (mobile.matches) {
      if (!init) {
        [...slides].forEach((v, i, a) => {
          v.classList.add('swiper-slide');
        });
        [...buttons].forEach((v, i, a) => {
          v.classList.remove('hidden');
        });
        wrapper.classList.remove('flex-wrap');
        init = true;
        swiper = new Swiper('.slim-line-brand-logos.swiper', {
          slidesPerView: 1,
          slidesPerGroup: 1,
          loop: false,
          spaceBetween: 20,
          navigation: {
            nextEl: '.slim-line-brand-logos-next',
            prevEl: '.slim-line-brand-logos-prev',
          },
        });
      }
    }

    // Disable (for tablet)
    else {
      if (init) {
        swiper.destroy();
        [...slides].forEach((v, i, a) => {
          v.classList.remove('swiper-slide');
        });
        [...buttons].forEach((v, i, a) => {
          v.classList.add('hidden');
        });
        wrapper.classList.add('flex-wrap');
        init = false;
      }
    }
  }

  swiperMode();

  window.addEventListener('resize', function () {
    swiperMode();
  });
}
